import { useParams } from 'react-router'
import { useSession } from '../../auth/session-context'
import { CompanyDossierPage } from '../../features/company/CompanyDossier'

/** S4 Company dossier (investor): `/app/companies/:id`. */
export function CompanyPage() {
  const { id = '' } = useParams()
  const me = useSession()
  const investor = me.memberships.some((m) => m.role === 'investor' || m.role === 'investor_admin')
  return <CompanyDossierPage issuerId={id} base="/app" org={null} canRecordActions={investor} />
}
